<template>
  <div>
    <h3>Map Settings</h3>
    <p>These settings relate to the map view.</p>

    <WizardMap :active="active" />

    <MapBounds
      no-wrapper
      :exclude="['bounds']"
      smaller-title
      sub-title="Map Bounds"
    />

    <BasemapConfig
      no-wrapper
      smaller-title
      :basemap-type.sync="basemapType"
      :basemap-default.sync="basemapDefault"
      :custom-url.sync="customUrl"
      :custom-attribution.sync="customAttribution"
    />

    <MapPopupSettings
      no-wrapper
      smaller-title
      sub-title="Map Popup"
    />

    <MapLegendsConfig
      no-wrapper
      smaller-title
      class="pt-2"
    />
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import { MAP_CONFIG_KEY } from '@/constants'
import MapBounds from '@/components/builder/MapSettings/MapBounds.vue'
import BasemapConfig from '@/components/builder/MapSettings/BasemapConfig.vue'
import MapPopupSettings from '@/components/builder/MapSettings/MapPopupSettings.vue'
import MapLegendsConfig from '@/components/builder/GeometryStyle/MapLegendsConfig.vue'
import WizardMap from '@/components/builder/MapSettings/WizardMap.vue'

const components = {
  MapBounds,
  BasemapConfig,
  MapPopupSettings,
  MapLegendsConfig,
  WizardMap,
}

const props = {
  active: Boolean,
}

@Component({ components })
export default class WizardMapSettings extends Vue.extend({ props }) {
  get basemapType () {
    return this.$typedStore.primary.app.config[MAP_CONFIG_KEY].basemapType
  }

  set basemapType (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, 'basemapType'],
      value,
    })
  }

  get basemapDefault () {
    return this.$typedStore.primary.app.config[MAP_CONFIG_KEY].basemapDefault
  }

  set basemapDefault (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, 'basemapDefault'],
      value,
    })
  }

  get customUrl () {
    return this.$typedStore.primary.app.config[MAP_CONFIG_KEY].basemapCustom.url
  }

  set customUrl (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, 'basemapCustom', 'url'],
      value,
    })
  }

  get customAttribution () {
    return this.$typedStore.primary.app.config[MAP_CONFIG_KEY].basemapCustom.attribution
  }

  set customAttribution (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, 'basemapCustom', 'attribution'],
      value,
    })
  }
}

</script>
